module.exports = __webpack_public_path__ + "img/lengthwise.3b3530ee.png";